import React, {useState} from 'react'
import '../Store/Store.css'
import FormatCurrency from '../Store/FormatCurrency'
import  {useCartContext} from '../context/CartContext'
import {Link} from 'react-router-dom'


const ProductItem = ({id, imgUrl, title, categories, price}) => {
  const {
    getItemQuantity,

    increaseCartQuantity,
    decreaseCartQuantity,
    getWishListQuantity,
    removeFromCart,
    addToWishList,
    removeFromWishList
  } = useCartContext();  
 
  const Quantity = getItemQuantity(id);  
  
  return (
      
    <div className='card_cart card'>
          <div className='card_cart2'>
      <button onClick={()=>addToWishList(id)} className='WishList' ><i  className="fa-solid fa-heart"></i></button>
          <Link to={`/Product_details/${id}` }><img src={imgUrl} alt='sora' /></Link>
        <h3>{title }</h3>
          <h5>{categories}</h5>
          <span>{FormatCurrency(price)}</span>
          <div>
             {Quantity === 0 ? <button onClick={() =>increaseCartQuantity(id)} className='add'> <i className="fa-solid fa-cart-shopping"></i> Add To Cart</button> : <div>
                
                <div className='addMore'>
                <button onClick={() =>increaseCartQuantity(id)}>+</button>   
                <span> {Quantity} In Cart</span>        
                <button onClick={() =>decreaseCartQuantity(id)}>-</button>        
                </div>
                    
                <button onClick={() =>removeFromCart(id) } className='remove '>Remove</button>
        </div> }
            
            </div> 

    </div>
    </div>

  )
}

export default ProductItem